import { render, staticRenderFns } from "./SupportReport.vue?vue&type=template&id=5024c5c4&scoped=true"
import script from "./SupportReport.vue?vue&type=script&lang=js"
export * from "./SupportReport.vue?vue&type=script&lang=js"
import style0 from "./SupportReport.vue?vue&type=style&index=0&id=5024c5c4&prod&scoped=true&lang=css"
import style1 from "./supportList.css?vue&type=style&index=1&id=5024c5c4&prod&scoped=true&lang=css&external"
import style2 from "./SupportReport.vue?vue&type=style&index=2&id=5024c5c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5024c5c4",
  null
  
)

export default component.exports